<template>
	<box :title="index" type="primary" no-padding>
		<div slot="tools">
			<button class="btn btn-success btn-sm">
				<i class="fal fa-seva"></i>
				Salvar
			</button>
		</div>
		<div slot="body" class="row">
			<div class="col-sm-6">
				<OptionsWorklab :options="item.values" />
			</div>
			<div class="col-sm-6">
				<OptionsSd2000 :lines="lines" />
			</div>
		</div>
	</box>
</template>
<script>
	import DropDraw from 'app/drop-draw';
	import box from 'app/box';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import OptionsWorklab from './components/options-worlab';
	import OptionsSd2000 from './components/options-sd2000';

	export default {
		components: {
			OptionsWorklab,
			OptionsSd2000,
			DropDraw,
			box,
		},
		props: {
			item: {
				default: () => ({}),
				type: Object,
			},
			index: {
				default: '',
				type: String,
			},
			lines: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/import/components/exames-nao-importados/components/item-importation/index.vue